// extracted by mini-css-extract-plugin
module.exports = {"noborder":"avatar-upload_noborder__SP_GU","withBorder":"avatar-upload_withBorder__1bGx2","avatarImg":"avatar-upload_avatarImg__2XflY","formHint":"avatar-upload_formHint__3zy_O"};